import Leger from "../../../../../components/categories/siakad/laporan_adab/rapor_sync/Home"
export default function Home() {
  
  return (
    <Leger />
  );
}
